'use client'

import { usePostHog } from 'posthog-js/react'
import { useEffect } from 'react'
import { Button } from '@/components/ui/button'

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string }
  reset: () => void
}) {
  const posthog = usePostHog()
  useEffect(() => {
    posthog.captureException(error, {
      path: window.location.pathname,
      error_capture_origin: 'global_error_boundary',
    })
  }, [error])

  return (
    <html lang='en'>
      <body className='flex min-h-screen flex-col items-center justify-center bg-background text-foreground'>
        <h2 className='mb-4 font-semibold text-2xl'>Something went wrong</h2>
        <Button onClick={reset} variant='default'>
          Try again
        </Button>
      </body>
    </html>
  )
}
